import { render, staticRenderFns } from "./HeaderNav.vue?vue&type=template&id=a53165e0&scoped=true"
import script from "./HeaderNav.vue?vue&type=script&lang=js"
export * from "./HeaderNav.vue?vue&type=script&lang=js"
import style0 from "./HeaderNav.vue?vue&type=style&index=0&id=a53165e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53165e0",
  null
  
)

export default component.exports